<template>
    <div class="sensitive-words-edit">
        <div class="edit-box">
            <textarea class="textarea scroll-tracker" :placeholder="placeHolder" ref="textInput"></textarea>
            <div class="edit-textarea-btn">
                <RoundButton class="add-words-btn" :text="addLabel" @btnClick="addClick" />
            </div>
        </div>
        <SensitiveList :data="curWords" @checkChange="itemCheckChange" />
        <div class="sensitive-operate" v-show="words.wordsArr && words.wordsArr.length">
            <div class="opt-select">
                <Checkbox name="allCheckBox" class="all-check" @valueChange="allCheckHandler" :data="isAllCheck" />
                <label class="all-label" for="allCheckBox">{{ allLabel }}</label>
                <Button class="delete-sensitive" @btnClick="deleteClick" :text="deleteText" :icon="deleteIcon" :hoverIcon="deleteHoverIcon"></Button>
            </div>
            <div class="page-control">
                <PageControl :total="sensitiveTotal" :curPage="curPage" :lengthRank="pageLengthRank" pageLength="20" @pageChange="pageChange" />
            </div>
        </div>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import Checkbox from "@/views/zhiji/bComponents/checks/Checkbox";
import Button from "@/views/zhiji/bComponents/buttons/Button";
import SensitiveList from "./SensitiveList";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import { arrayDeduplicate } from "@/views/zhiji/js/common/util.js";
import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js";
import i18n from "@/i18n";

export default {
    name: "SensitiveWordsEdit",
    props: ["words"],
    components: {
        RoundButton,
        SensitiveList,
        Checkbox,
        Button,
        PageControl
    },
    data() {
        return {
            deleteIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px 0px",
            deleteHoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px -22px",
            checkedRows: [],
            curPage: 1,
            pageLengthRank: ["10", "20", "30"],
            curWords: [],
            isAllCheck: false
        };
    },
    watch: {
        curPageWords: {
            handler(data) {
                this.curWords = data;
            },
            immediate: true,
            deep: true
        },
        checkedRows(data) {
            if (data.length === 0) {
                this.isAllCheck = false;
            }

            if (data.length === this.curPageWords.length) {
                this.allPageChecked();
            }
        },
        allCheck: {
            handler(val) {
                this.isAllCheck = val;
            },
            immediate: true
        }
    },
    computed: {
        allCheck() {
            return this.checkedRows.length !== 0 && this.getStorePorp("curPageWords").length == this.checkedRows.length;
        },
        placeHolder() {
            return this.$t("zhiji.sensitiveWord.enterWordsTip");
        },
        addLabel() {
            return this.$t("zhiji.common.add");
        },
        allLabel() {
            return this.$t("zhiji.common.selectAll");
        },
        deleteText() {
            return this.$t("zhiji.common.delete");
        },
        sensitiveTotal() {
            return this.getStorePorp("allSensitiveWords").length;
        },
        curPageWords() {
            return this.getStorePorp("curPageWords");
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.sensitiveWords[propName];
        },
        addClick() {
            let text = this.$refs.textInput.value;
            let result = text.split("\n");

            result =
                result.length > 0 &&
                result.filter(item => {
                    return this.zhiji.strTrim(item) && item.length > 0;
                });

            result.length > 0 && this.updateSensitiveWords(arrayDeduplicate(result));

            this.$refs.textInput.value = "";
        },
        updateSensitiveWords(data) {
            this.$store.commit("zhiji/editUpdateSensitive", {
                type: "addContent",
                newWords: data
            });
        },
        pageChange(data) {
            this.curPage = data.curPage;
            this.querySensitiveData(data.curPage);
        },
        querySensitiveData(data) {
            this.$store.commit("zhiji/getSensitiveListData", {
                pageNo: data,
                pageSize: 20
            });
        },
        allCheckHandler(data) {
            data.checked ? this.allPageChecked() : this.removeAllChecked();
        },
        allPageChecked() {
            let wordsList = this.curPageWords;
            this.curWords = wordsList.map(word => {
                this.itemCheckChange({
                    uId: word.uId,
                    checked: true
                });
                return {
                    ...word,
                    checked: true
                };
            });
        },
        itemCheckChange(data) {
            if (data.checked) {
                this.checkedRows.indexOf(data.uId) === -1 && this.checkedRows.push(data.uId);
            } else {
                let itemcheckedIdx = this.checkedRows.indexOf(data.uId);
                itemcheckedIdx !== -1 && this.checkedRows.splice(itemcheckedIdx, 1);
            }

            this.curPageWords.forEach(item => {
                if (item.uId == data.uId) {
                    item.checked = data.checked;
                }
            });
        },
        removeAllChecked() {
            this.curWords = this.curPageWords.map(word => {
                return {
                    ...word,
                    checked: false
                };
            });
            this.checkedRows.splice(0);
        },
        deleteClick() {
            this.checkedRows.length > 0 &&
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.sensitiveWord.delWordConfim"),
                        cancel: () => {},
                        confirm: () => {
                            this.$store.commit("zhiji/editUpdateSensitive", {
                                type: "deleteContent",
                                wordItem: this.checkedRows
                            });
                        }
                    }
                });
        }
    }
};
</script>

<style lang="less" scoped>
.sensitive-words-edit {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: 24px;
    .edit-box {
        flex: 1;
        display: flex;
        flex-direction: row;
        margin-top: 8px;
    }
    .textarea {
        width: 500px;
        max-width: 80%;
        margin-right: 8px;
        padding: 8px;
        height: 130px;
        box-sizing: border-box;
        border: 1px solid #d8e4f0;
        border-radius: 4px;
        outline: none;
    }
    .sensitive-operate {
        width: 604px;
        border-top: 1px solid #d8e4f0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .opt-select {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 12px 16px 16px 0;
            flex-grow: 0;
            flex-shrink: 0;
            .all-check {
                margin-right: 8px;
            }
            .all-label {
                font-size: 12px;
                margin: 0 24px 0 0;
            }
            .delete-sensitive {
                font-size: 12px;
            }
        }
        .page-control {
            position: relative;
            margin-right: 16px;
            padding: 16px 0 16px 0;
            flex-grow: 0;
            flex-shrink: 0;
            height: 32px;
            display: flex;
            align-items: flex-start;
            text-align: center;
            color: rgba(65, 71, 94, 0.7);
            justify-content: center;
            font-weight: 400;
        }
    }
}
</style>
